import { render, staticRenderFns } from "./jobGradeList.vue?vue&type=template&id=2a1ff4d1"
import script from "./jobGradeList.vue?vue&type=script&lang=js"
export * from "./jobGradeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports